'use client'
import Link from 'next/link'
import React from 'react'
import {
   Autoplay,
   EffectFade,
   EffectFlip,
   Navigation,
   Pagination,
} from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function BlogSection() {
   return (
      <section className="home-blog-section p-0">
         <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            effect="fade"
            autoplay={{
               delay: 5000,
               disableOnInteraction: false,
            }}
            slidesPerView={1}
            grabCursor={true}
            spaceBetween={30}
            freeMode={false}
            loop={true}
            keyboard={{ enabled: true }}
            speed={600}
            pagination={{
               el: '.blog-swiper-pagination',
               clickable: true,
            }}
            navigation={{
               nextEl: '.blog-swiper-next',
               prevEl: '.blog-swiper-prev',
            }}
            className="blog-swiper"
         >
            <SwiperSlide>
               <div className="blog-section blog1">
                  <video className="d-none" autoPlay muted loop preload="auto">
                     <source
                        src="/assets/videos/home/blog-v.mp4"
                        type="video/mp4"
                     />
                  </video>
                  <div className="blog-video-background">
                     <video autoPlay muted loop preload="auto">
                        <source
                           src="/assets/videos/home/blog-v.mp4"
                           type="video/mp4"
                        />
                     </video>
                  </div>
                  <div className="blog-title">
                     <h3>Explore our hottest blogs</h3>
                  </div>
                  <div className="blog1-content">
                     <p className="blog-sub-title">GREEN TECH</p>
                     <p className="blog-sub-title-2">the next biggest buzz?</p>
                     <Link
                        href="/blog/greentech" ///blog-details/greenTech-details
                        className="see-more-btn-section"
                        aria-label="See more about Green Tech"
                     >
                        <button className="see-more-btn">See more</button>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide>
               <div className="blog-section blog2">
                 
                  <div className="blog-title">
                     <h3>Explore our hottest blogs</h3>
                  </div>
                  <div className="blog2-content">
                     <p className="blog-sub-title mb-0">AR & VR</p>
                     <p className="blog-sub-title-2">
                        Let’s Walk Into The Future
                     </p>
                     <Link
                        href="/blog/ar-vr" ///blog-details/ar-vr-details
                        className="see-more-btn-section"
                        aria-label="See more about AR & VR"
                     >
                        <button className="see-more-btn">See more</button>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide>
               <div className="blog-section blog3">
                 
                  <div className="blog-title">
                     <h3>Explore our hottest blogs</h3>
                  </div>
                  <div className="blog3-content">
                     <p className="blog-sub-title">Media & Entertainment</p>
                     <p className="blog-sub-title-2">
                        A Battle Against Your Attention?
                     </p>
                     <Link
                        href="/blog/media-entertainment" ///blog-details/media-ent-Details
                        className="see-more-btn-section"
                        aria-label="See more about Media & Entertainment"
                     >
                        <button className="see-more-btn">See more</button>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <div className="swiper-button-next blog-swiper-next"></div>
            <div className="swiper-button-prev blog-swiper-prev"></div>
            <div className="swiper-pagination blog-swiper-pagination"></div>
         </Swiper>
      </section>
   )
}

export default BlogSection
